import pkg from "../package.json"

/** Canonical product release version for frontend display and diagnostics. */
export const RELEASE_VERSION = pkg.version
export const DISPLAY_RELEASE_VERSION = `v${RELEASE_VERSION}`
